<template>
  <custom-callout
    :border-color="getEditDistributionColor"
    class="mb-3 custom-callout"
    :has-toggle="false"
  >
    <validation-observer ref="editDistributionNumber" novalidate tag="form">
      <div class="row">
        <div class="col mt-4">
          <icon-view
            icon="fa fa-edit"
            icon-background="#fff"
            icon-color="#2DB782"
            title="Modificación de la Distribución de Cifras de Cuenta"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-3 col-sm-12 col-spacing service-place-spacing">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="ageGroupDd"
              v-model="ageGroup"
              :clearable="false"
              custom-error-msg="El grupo de edad es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Grupo de Edad:"
              :options="ageGroupList"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div class="col-md-4 col-sm-12 col-spacing">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="oldPurchaseOrderIdDd"
              v-model="oldPurchaseOrderId"
              :clearable="false"
              custom-error-msg="El número de Grant actual es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Número de Grant actual:"
              :options="purchaseOrdersInBill"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div
          class="col-md-1 col-sm-12 d-none d-md-flex align-items-end justify-content-center"
        >
          <div class="icon">
            <span class="dot text-center py-2 px-1">
              <i
                class="orange-icon orange-icon-badge-align fas fa-arrow-circle-right"
              />
            </span>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 col-spacing">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="newPurchaseOrderIdDd"
              v-model="newPurchaseOrderId"
              :clearable="false"
              custom-error-msg="El número de Grant a modificar es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Número de Grant a modificar:"
              :options="purchaseOrders"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
      </div>

      <div class="row">
        <div class="col d-flex d-md-block d-sm-flex mt-5 text-right">
          <action-button
            id="cancelEditBtn"
            i="fas fa-times-circle"
            variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
            @click="cancelEdit"
          >
            Cancelar
          </action-button>
          <action-button
            id="editDistributionNumberBtn"
            i="fas fa-sync-alt"
            variant="success pl-4 pr-4"
            @click="editDistributionNumber"
          >
            Actualizar
          </action-button>
        </div>
      </div>
    </validation-observer>
  </custom-callout>
</template>
<script>
import CustomCallout from 'custom-callout';
import CustomDropDown from 'custom-drop-down';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import ActionButton from 'ActionButton';
import { Colors } from '@/components/common';
import IconView from 'icon-view';
import { updateProjectIdBulk } from '@/modules/billingHistory/api';

export default {
  name: 'EditDistributionNumber',
  components: {
    IconView,
    CustomDropDown,
    CustomCallout,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    billId: {
      type: Number,
      default: () => null,
    },
    ageGroupList: {
      type: Array,
      default: () => [],
    },
    purchaseOrders: {
      type: Array,
      default: () => [],
    },
    purchaseOrdersInBill: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ageGroup: null,
      oldPurchaseOrderId: null,
      newPurchaseOrderId: null,
    };
  },
  computed: {
    getEditDistributionColor() {
      return Colors.GREEN;
    },
  },
  methods: {
    async cancelEdit() {
      this.ageGroup = null;
      this.oldPurchaseOrderId = null;
      this.newPurchaseOrderId = null;
      this.$emit('cancel-edit', true);
    },
    async editDistributionNumber() {
      const isValid = await this.$refs.editDistributionNumber.validate();
      if (!isValid) {
        this.ShowToast(
          '',
          'Favor, debe completar los campos para continuar.',
          'error'
        );
        return;
      }

      const group = this.ageGroupList.find((x) => x.id == this.ageGroup.id);

      const isConfirmed = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea actualizar la distribución para el grupo de edad ${group.name}?`,
        'Sí',
        'No'
      );

      if (!isConfirmed) return;

      await updateProjectIdBulk({
        billId: this.billId,
        ageGroupId: this.ageGroup.id,
        oldPurchaseOrderId: this.oldPurchaseOrderId.id,
        newPurchaseOrderId: this.newPurchaseOrderId.id,
      })
        .then((r) => {
          if (!r.data) {
            this.ShowToast(
              '',
              'El número de Grant actual no coincide con el grupo de edad en la distribución de la cifra de cuenta.',
              'error'
            );
            return;
          }

          this.ShowToast(
            'Proceso Exitoso',
            'La distribución de cifras de cuenta ha sido actualizada exitosamente.',
            'success'
          );
          this.$emit('updated', true);
        })
        .catch((error) => {
          this.ShowToast('', error.response.data.message, 'error');
        });
    },
  },
};
</script>
<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.icon {
  font-size: 23px;
  color: map-get($colors, 'gray-2');
}
</style>
